import en from "./en";

export default {
  ...en,
  metaTitleBrand: "LOYA SPORT",
  metaTitleHome: "ホーム",
  metaTitleProducts: "製品",
  metaTitleProductDetail: "製品詳細",
  metaTitleCustomService: "カスタムサービス",
  metaTitleSolutions: "ソリューション",
  metaTitleAbout: "会社概要",
  metaTitleContact: "お問い合わせ",
  metaTitleBlog: "ブログ",
  metaTitleLogin: "ログイン",
  metaTitleAdmin: "管理ダッシュボード",
  metaTitleSystemSetup: "システム設定",
  authLogin: {
    ...en.authLogin,
    welcomeBack: "おかえりなさい",
    brandIntro: "ログインしてヨガ・フィットネス製品の調達を続けましょう。",
    brandBullet1: "迅速なRFQ対応",
    brandBullet2: "商品・注文フォロー",
    brandBullet3: "B2Bアカウントサポート",
    accountLogin: "アカウントログイン",
    createAccount: "アカウント作成",
    recoverPassword: "パスワード再設定",
    registrationComplete: "登録完了",
    passwordUpdated: "パスワード更新完了",
    loginDesc: "ユーザー名またはメールアドレスとパスワードで続行してください。",
    registerDesc: "ユーザー名、メール認証、captcha保護でアカウントを作成します。",
    forgotDesc: "アカウントのメールアドレスを入力すると、リセットコードを受け取って新しいパスワードを設定できます。",
    registerSuccessDesc: "アカウントの作成が完了しました。自動でログイン画面に戻ります。",
    resetSuccessDesc: "パスワードが更新されました。自動でログイン画面に戻ります。",
    redirectHintPrefix: "ログイン画面へ",
    redirectHintSuffix: "後に切り替わります。",
    seconds: "秒",
    loginNow: "今すぐログイン",
    username: "ユーザー名",
    usernamePlaceholder: "3文字以上、例: loya_buyer",
    usernameHelp: "ユーザー名は3文字以上で、予約語は使用できません。使用可能文字は英字・数字・アンダースコア・ハイフンです。",
    usernameExistsHint: "このユーザー名は既に登録されています。直接ログインするか別のユーザー名を使用してください。",
    usernameExists: "このユーザー名は既に存在します。別のユーザー名を使用するか直接ログインしてください。",
    usernameExistsAction: "ユーザー名あり、ログインへ",
    usernameAlreadyRegistered: "このユーザー名は既に登録されています。",
    usernameAvailable: "ユーザー名は利用可能です。",
    usernameVerifyFailed: "現在ユーザー名を確認できません。しばらくして再試行してください。",
    checkingUsername: "ユーザー名の利用可否を確認中...",
    email: "メールアドレス",
    emailPlaceholder: "your@email.com",
    emailCodeTargetHint: "認証コードを受け取るメールアドレスを入力してください。",
    emailExistsHint: "このメールアドレスは既に登録されています。直接ログインするか別のメールを使用してください。",
    emailExists: "このメールアドレスは既に存在します。別のメールを使用するかログインへ進んでください。",
    emailExistsAction: "メールあり、ログインへ",
    emailAlreadyRegistered: "このメールアドレスは既に登録されています。",
    emailAvailable: "メールアドレスは利用可能です。",
    emailVerifyFailed: "現在メールアドレスを確認できません。しばらくして再試行してください。",
    checkingEmail: "メールアドレスの利用可否を確認中...",
    usernameOrEmail: "ユーザー名またはメール",
    usernameOrEmailPlaceholder: "ユーザー名 または your@email.com",
    forgotEmailHint: "アカウントに紐づくメールアドレスを入力してください。リセットコードを送信します。",
    password: "パスワード",
    passwordPlaceholder: "パスワードを入力",
    confirmPassword: "パスワード確認",
    confirmPasswordPlaceholder: "パスワードを再入力",
    confirmNewPassword: "新しいパスワード確認",
    confirmNewPasswordPlaceholder: "新しいパスワードを再入力",
    nickname: "ニックネーム",
    nicknamePlaceholder: "任意（表示用）",
    captcha: "Captcha",
    registerCaptcha: "登録用captcha",
    resetCaptcha: "リセット用captcha",
    refreshCaptcha: "captchaを更新",
    load: "読み込み",
    forgotCaptchaHint: "先にcaptchaを完了してからリセットコードを送信してください。送信後、最終提出用に新しいcaptchaが自動で表示されます。",
    registerCaptchaHint: "先にcaptchaを完了してからメール認証コードを送信してください。",
    registerStepHint: "先にユーザー名、パスワード、確認パスワード、有効なメールを入力してください。その後captchaとメールコード欄が表示されます。",
    emailCode: "メールコード",
    emailCodePlaceholder: "6桁コード",
    resetCode: "リセットコード",
    resetCodePlaceholder: "6桁リセットコード",
    sending: "送信中...",
    resendIn: "再送まで",
    sendEmailCode: "メールコードを送信",
    sendResetCode: "リセットコードを送信",
    signingIn: "ログイン中...",
    login: "ログイン",
    updating: "更新中...",
    creating: "作成中...",
    resetPassword: "パスワードをリセット",
    forgotRequirementHint: "パスワード再設定にはcaptcha認証とメールに送信されたリセットコードの両方が必要です。",
    registerRequirementHint: "登録には受信したメールコードの認証が必要です。",
    captchaRefreshHint: "captchaが見づらい場合は右側の画像をクリックして更新してください。",
    switchToLogin: "アカウントをお持ちですか？ログイン",
    switchToRegister: "アカウントがまだありませんか？登録する",
    backToLogin: "ログインに戻る",
    forgotPassword: "パスワードをお忘れですか？",
    usernameRequired: "3文字以上のユーザー名を入力してください。",
    usernameMin: "ユーザー名は3文字以上必要です。",
    usernameMax: "ユーザー名は24文字以内にしてください。",
    usernamePattern: "ユーザー名には英字・数字・アンダースコア・ハイフンのみ使用できます。",
    usernameReserved: "このユーザー名は予約語です。別の名前を選択してください。",
    usernameFormatOk: "ユーザー名の形式は有効です。",
    emailRequired: "メールアドレスを入力してください。",
    emailInvalid: "有効なメールアドレスを入力してください。",
    emailFormatOk: "メールアドレスの形式は有効です。",
    emailProviderHint: "可能であれば Gmail、Outlook、QQ Mail、163、126、Foxmail など一般的なメールサービスの利用を推奨します。",
    didYouMean: "こちらですか",
    passwordMin: "パスワードは6文字以上必要です。",
    newPasswordMin: "新しいパスワードは6文字以上必要です。",
    confirmPasswordRequired: "確認用パスワードを入力してください。",
    passwordMatch: "パスワードが一致しています。",
    passwordMismatch: "2つのパスワードが一致しません。",
    emailCodeRequired: "メール認証コードを入力してください。",
    resetCodeRequired: "メールに送信されたリセットコードを入力してください。",
    captchaRequired: "captchaコードを入力してください。",
    registerPrerequisitesError: "メールコードを送信する前に、ユーザー名・パスワード・確認パスワード・有効なメールを入力してください。",
    enterCaptchaBeforeEmailCode: "メール認証コードを送信する前にcaptchaを入力してください。",
    enterCaptchaBeforeResetCode: "パスワードリセットコードを送信する前にcaptchaを入力してください。",
    sendEmailCodeFailed: "メール認証コードの送信に失敗しました。もう一度お試しください。",
    emailCodeSent: "メール認証コードを送信しました。",
    registerFailed: "登録に失敗しました",
    resetFailed: "パスワードのリセットに失敗しました",
    loginFailed: "ログインに失敗しました",
    registerSuccessNotice: "登録が完了しました。約4秒後にログイン画面へ戻ります。",
    resetSuccessNotice: "パスワードのリセットが完了しました。約1.5秒後にログイン画面へ戻ります。",
    loginTokenMissing: "ログイントークンがありません",
    profileLoadFailed: "アカウントプロフィールの読み込みに失敗しました",
    loginSuccessAdmin: "ログイン成功。リダイレクト中...",
    loginSuccessStorefront: "ログイン成功。ストアフロントへ移動します...",
    loginServiceUnavailable: "ログインサービスは一時的に利用できません。しばらくして再試行してください。",
    accountNotFound: "アカウントが見つかりません。ユーザー名またはメールアドレスを確認してください。",
    passwordIncorrect: "パスワードが間違っています。再試行してください。",
    registrationNotOpen: "現在、ログインおよび新規登録は受け付けていません。",
    accountRestricted: "このアカウントは制限されています。管理者にお問い合わせください。",
    captchaExpired: "キャプチャが期限切れです。ページを更新して再試行してください。",
    captchaIncorrect: "キャプチャコードが間違っています。再試行してください。",
    passwordRequired: "パスワードを入力してください。",
    emailCodeSentInbox: "確認コードを送信しました。受信トレイを確認してください。",
    previewCodeCurrentEnv: "現在の環境のプレビューコード",
    previewCodeDevelopment: "開発環境のプレビューコード",
    previewCodeGenerated: "確認コードが生成されました。この環境ではプレビューコードを使用しています。",
    previewCodeContinueRegistration: "登録を続けるにはこの6桁のコードを入力してください。",
    tooManyRequests: "リクエストが多すぎます。しばらくたってから再試行してください。",
    smtpConfigRetry: "メールの送信に失敗しました。SMTP設定を確認して再試行してください。",
    emailServiceNotConfigured: "メールサービスが設定されていません。管理者にお問い合わせください。",
    requestFailed: "リクエストに失敗しました。再試行するかサポートにお問い合わせください。",
    orContinueWith: "または続ける",
    googleAuthorizing: "Googleアカウントを認証中...",
    googleFallbackAction: "Googleで続ける",
    googleAuthFailed: "Google認証に失敗しました",
    googleAuthOffline: "Googleログインはオフライン環境では利用できません。インターネットに接続するか、ユーザー名とパスワードでログインしてください。",
    googleAuthTimeout: "Google認証がタイムアウトしました。再試行してください。問題が続く場合は、管理者にサーバーのネットワークアクセスを確認するよう依頼してください。",
    googleAuthNetworkError: "Google認証がサーバーのネットワークエラーにより失敗しました。管理者にお問い合わせください。",
    googleRegisterSuccess: "Googleアカウントの連携に成功しました。ストアフロントに移動します...",
    googleCreateAccountTitle: "Google登録を完了する",
    googleCreateAccountDesc: "Googleがメールアドレスを認証しました。パスワードを設定して顧客アカウントを作成し、ログインを完了してください。",
    googleCreateAccountHint: "このGoogleメールアドレスに連携するアカウントがありません。パスワードを設定して顧客アカウントを作成してください。",
    googleLinkedEmailHint: "このGoogle認証済みメールアドレスで顧客アカウントを作成します。",
    googleCreatePasswordHint: "パスワードを設定・確認してください。新しい顧客アカウントにGoogle認証済みメールアドレスを使用します。"
  },

  // --- storefront ---
  navHome: "ホーム",
  navProducts: "製品",
  navCustomization: "カスタムサービス",
  navSolutions: "ソリューション",
  navAbout: "会社概要",
  navContact: "お問い合わせ",

  navYogaMats: "ヨガマット",
  navYogaBlocks: "ヨガブロック",
  navYogaStraps: "ヨガストラップ",
  navResistanceBands: "レジスタンスバンド",
  navPilatesRings: "ピラティスリング",
  navFoamRollers: "フォームローラー",
  navOemPrivateLabel: "カスタムサービス",
  navSolutionsControl: "品質管理",
  navCompanyProfile: "会社概要",
  navContactUs: "お問い合わせ",
  navBlog: "Blog",

  btnContactUs: "お問い合わせ",
  btnLogin: "ログイン",
  btnAccount: "アカウント",
  btnQuote: "見積もり依頼",
  btnCurrency: "通貨",
  btnLanguage: "言語",

  seeAllCategories: "すべてのカテゴリーを見る",
  productDetailReady: "プライベートラベル対応",
  productDetailQuote: "見積もり対応",
  productDetailViewSpecs: "仕様を見る",
  productDetailRequestQuote: "見積もり依頼",
  pdLoadErrorProductDetail: "商品詳細の読み込みに失敗しました",
  pdLoadErrorRelatedProducts: "関連商品の読み込みに失敗しました",
  pdLoadErrorStorefrontConfig: "ストア設定の読み込みに失敗しました",
  pdLoading: "商品詳細を読み込み中...",
  pdSampleDefaultMessage: "サンプル方針、納期、見積詳細をご共有ください。",
  pdAttrProductName: "商品名",
  pdAttrModelNo: "型番",
  pdAttrCategory: "カテゴリ",
  pdAttrManufacturer: "メーカー",
  pdLeadTimeOnRequest: "納期はお問い合わせください",
  pdLeadTimeUpTo: "{qty}個まで: {days}日",
  pdLeadTimeFrom: "{qty}個以上: {days}日",
  pdLeadTimeDaysOnly: "{days}日",
  pdContactForQuote: "見積もりはお問い合わせください",
  pdPerPiece: "{price} / 個",
  pdAnonymousBuyer: "匿名バイヤー",
  pdReviewTipSignIn: "役立つ投票には顧客としてログインしてください。",
  pdReviewTipSessionExpired: "セッションの有効期限が切れました。再ログインしてください。",
  pdReviewTipNoPermission: "現在のアカウントでは役立つ投票ができません。",
  pdReviewTipUpdateFailed: "役立つ状態の更新に失敗しました",
  pdSpecValues: "値",
  pdSpecRequired: "必須",
  pdSpecOptional: "任意",
  pdCapabilityCustomLogo: "ロゴカスタマイズ対応",
  pdCapabilitySampleDev: "サンプルベース開発対応",
  pdCapabilityPackagingCoordination: "包装調整対応",
  pdCapabilityExportFollowUp: "輸出出荷フォロー対応",
  pdPackagingSellingUnit: "販売単位",
  pdPackagingSingleItem: "単品",
  pdPackagingType: "包装",
  pdPackagingTypeFallback: "OPP袋 / 輸出用カートン",
  pdPackagingLoadingAdvice: "積載アドバイス",
  pdPackagingLoadingAdviceFallback: "注文構成に基づく",
  pdPackagingLeadTime: "納期",
  pdMediaPhotoLabel: "写真 {index}",
  pdMediaVideoLabel: "動画",
  pdMediaAttributesLabel: "属性",
  pdPackagingPointPackaging: "包装: {value}",
  pdPackagingPointLoadingAdvice: "積載アドバイス: {value}",
  pdPackagingPointShippingPort: "出荷港: {value} (応相談)",
  pdPackagingPointShippingPortNegotiable: "出荷港: 応相談",
  pdPackagingPointLeadTime: "納期: {value}",
  pdInquiryHello: "こんにちは。以下の商品について問い合わせしたいです:",
  pdInquiryProduct: "商品: {value}",
  pdInquirySku: "SKU: {value}",
  pdInquirySkuName: "SKU名: {value}",
  pdInquiryModel: "型番: {value}",
  pdInquiryQuantity: "数量: {value}",
  pdEmailSubject: "問い合わせ: {sku} - {name}",
  pdInquirySubmitFailed: "現在問い合わせを送信できません。",
  pdSampleContactPerson: "担当者: {value}",
  pdSampleWhatsapp: "WhatsApp/WeChat: {value}",
  pdSampleCompany: "会社名: {value}",
  pdSampleRequestedQuantity: "希望数量: {value}",
  pdSampleSelectorQuantity: "ページ数量セレクター: {value}",
  pdVariationLabel: "オプション",
  pdVariationInquiryIntro: "こんにちは。次の内容で問い合わせしたいです:",
  pdVariationInquiryQuoteLeadTime: "最新の見積もりと納期をご共有ください。",
  pdVideoFallback: "動画の読み込みに失敗しました。再試行するか元URLを開いてください。",
  pdRetry: "再試行",
  pdOpenVideoUrl: "動画URLを開く",
  pdProductAttributes: "商品属性",
  pdMediaTabsAria: "商品メディア種別",
  pdMediaTabPhotos: "写真",
  pdMediaTabVideo: "動画",
  pdMediaTabAttributes: "属性",
  pdInfoTabsAria: "詳細情報タブ",
  pdInfoTabAttributes: "属性",
  pdInfoTabDescription: "説明",
  pdInfoTabSupplier: "サプライヤー",
  pdInfoTabReviews: "レビュー",
  pdKeyAttributes: "主要属性",
  pdPackagingShippingInfo: "包装・配送情報",
  pdProductDescription: "商品説明",
  pdSupplierOverview: "サプライヤー概要",
  pdSupplierOverviewHint: "会社情報とFAQは詳細画像の下に表示されます。",
  pdBuyerFeedback: "購入者フィードバック",
  pdRepeatBuyer: "リピーター",
  pdReviewRatingAria: "評価 {rating} / 5",
  pdReviewMetaColor: "カラー: {value}",
  pdReviewMetaColorFallback: "2番目",
  pdReviewUnavailable: "この商品は現在利用できません",
  pdReviewHelpful: "役立つ ({count})",
  pdNoReviews: "この商品のレビューはまだありません。",
  pdNoReviewsHint: "注文事例やサンプル評価はチームまでお問い合わせください。",
  pdTitleFallback: "商品詳細",
  pdCustomizable: "カスタマイズ可能",
  pdVariationCardAria: "商品バリエーション",
  pdVariations: "バリエーション",
  pdSelectNow: "今すぐ選択",
  pdSelectOption: "オプションを選択",
  pdLadderPricingAria: "段階価格",
  pdProductSpecifications: "商品仕様",
  pdSpecPrevAria: "前の仕様値を表示",
  pdSpecNextAria: "次の仕様値を表示",
  pdSupplierCapability: "サプライヤーのカスタマイズ能力",
  pdGetFreeSample: "無料サンプルを取得",
  pdWhatsAppInquiry: "WhatsApp問い合わせ",
  pdEmailInquiry: "メール問い合わせ",
  pdPackagingDelivery: "包装と配送",
  pdProductVideo: "商品動画",
  pdVideoOpenLink: "現在の環境では動画を再生できません。",
  pdSupplierDescriptions: "サプライヤーの商品説明",
  pdCompanyIntroduction: "会社紹介",
  pdNoCompanyIntroduction: "会社紹介は未設定です。",
  pdFaq: "FAQ",
  pdNoFaq: "FAQは未設定です。",
  pdCloseVariationSelector: "バリエーションセレクターを閉じる",
  pdVariationSelectAndQty: "バリエーションと数量を選択",
  pdVariationStock: " / 在庫 {count}",
  pdSelectedQuantity: "選択数量",
  pdSendInquiry: "問い合わせ送信",
  pdChatNow: "今すぐチャット",
  pdOptionLabel: "オプション {index}",
  pdRelatedAria: "関連商品",
  pdRelatedTitle: "関連商品",
  pdRelatedSubtitle: "このカテゴリでよく一緒に調達される商品です。",
  pdRelatedPrevAria: "前の関連商品",
  pdRelatedNextAria: "次の関連商品",
  pdSampleContactTitle: "お問い合わせください",
  pdSampleContactDesc: "ご不明点があればお気軽にご連絡ください。サンプル対応はWhatsAppまたはメールで受け付けています。",
  pdSampleCloseAria: "サンプル問い合わせを閉じる",
  pdSampleSummaryProduct: "商品",
  pdSampleSummaryQuantity: "数量",
  pdFormFullName: "氏名",
  pdFormFullNamePlaceholder: "お名前",
  pdFormEmail: "メール*",
  pdFormEmailPlaceholder: "メールでご連絡します",
  pdFormWhatsapp: "WhatsApp/WeChat*",
  pdFormWhatsappPlaceholder: "WhatsAppでご連絡します",
  pdFormCompany: "会社名",
  pdFormCompanyPlaceholder: "会社名",
  pdFormRequiredQuantity: "必要数量",
  pdFormRequiredQuantityPlaceholder: "サンプルまたは試験注文の必要数量",
  pdFormMessage: "メッセージ",
  pdFormMessagePlaceholder: "商品要件を簡潔にご記入ください",
  pdFormSending: "送信中...",
  pdFormSendMessage: "メッセージ送信",
  pdFormInquirySuccess: "問い合わせを送信しました。",

  carouselLoadingTitle: "バナー画像を読み込み中",
  carouselLoadingBody:
    "ホームページ用のビジュアルを準備しています。バナー画像の読み込みが完了するまで少々お待ちください。",
  carouselPlaceholderTitle: "バナー画像を準備中です",
  carouselPlaceholderBody:
    "画像リソースの準備が完了すると、ここにホームページのカルーセルが表示されます。",

  // --- OEM / custom service ---
  oemHeroKicker: "カスタムサービス",
  oemTitle: "明確な生産フローでオリジナルヨガラインを構築",
  oemIntro:
    "海外バイヤー向けに、ヨガおよび軽フィットネスカテゴリーの商品カスタマイズ、包装開発、サンプル対応、受注実行をサポートします。",
  oemStartProject: "カスタム案件を開始",
  oemBrowseProducts: "ベース商品を見る",
  oemVisualGuide: "カスタマイズビジュアルガイド",
  oemVisualAlt: "OEMカスタマイズ項目と工程ガイド",
  oemVisualPlaceholder:
    "カスタマイズ画像が見つかりません。frontend/public/assets/about/oem-customization-guide.jpg に画像を追加してください。",
  oemCapabilityKicker: "対応可能なカスタマイズ",
  oemCapabilityTitle: "ロゴ加工から包装一式まで対応",
  oemProjectBrief: "案件概要",

  oemCapability1:
    "主要なヨガアクセサリーに対し、ロゴ印刷、エンボス加工、レーザーマーキングに対応します。",
  oemCapability2:
    "対象市場に合わせて、色・素材・質感・サイズを調整できます。",
  oemCapability3:
    "店頭販売向けパッケージ、インサートカード、バーコードラベル、カートンマークに対応します。",
  oemCapability4:
    "スタジオ向けセット、Amazon向けパック、季節販促向けバンドル開発に対応します。",

  oemProcess1Title: "ご要望を共有",
  oemProcess1Body:
    "対象商品、ロゴデータ、参考画像、包装要件、予定数量をご共有ください。",
  oemProcess2Title: "仕様とMOQの確認",
  oemProcess2Body:
    "素材選定、ブランド加工方法、適合要件、納期、対応可能な最小数量を確認します。",
  oemProcess3Title: "サンプル作成と修正",
  oemProcess3Body:
    "サンプルまたはモックアップを手配し、フィードバックを反映して量産基準を確定します。",
  oemProcess4Title: "量産と検品",
  oemProcess4Body:
    "承認済みサンプルに基づいて量産し、包装確認と出荷前品質チェックを実施します。",

  // --- news ---
  newsHeroKicker: "業界アップデート",
  newsTitle: "ニュース＆アップデート",
  newsIntro:
    "フィットネスアクセサリーのバイヤー向けに、最新の調達情報、商品リリース情報、輸出関連の更新情報をご案内します。",
  newsSectionTitle:
    "カスタム案件のお知らせや新コレクション情報については、最新カタログを営業チームまでお問い合わせください。",

  news1Title: "春の調達ガイドを公開",
  news1Body:
    "次の販売シーズンに向けた、ヨガ・ピラティス・リカバリー商品の最新トレンドをご確認いただけます。",
  news2Title: "OEM包装の更新",
  news2Body:
    "プライベートラベル向けに、より環境配慮型の外箱、インサートカード、バーコード包装オプションをご提供開始しました。",
  news3Title: "輸出スケジュールのお知らせ",
  news3Body:
    "リードタイムと出荷枠は毎週更新しており、バイヤーの発売計画をより正確に支援します。",

  // --- contact ---
  contactHeroKicker: "ビジネス問い合わせ",
  contactTitle: "サプライヤーへ連絡",
  contactIntro:
    "商品要件と対象市場をご共有ください。見積詳細とリードタイム見込みをご案内します。",
  contactFormTitle: "問い合わせ送信",
  contactName: "お名前",
  contactEmail: "業務用メール",
  contactCompany: "会社名",
  contactMessage: "商品仕様、数量、出荷先",
  contactSubmit: "問い合わせ送信",
  contactSent: "メッセージを送信しました。",

  contactInfoTitle: "営業窓口",
  contactInfoEmail: "メール",
  contactInfoPhone: "電話",
  contactInfoHours: "営業時間: 月-土 09:00-18:00 (GMT+8)",
  contactInfoNote:
    "推奨連絡手段: 正式見積はメール、緊急納期確認は電話をご利用ください。",

  contactResponseTitle: "平均応答時間",
  contactResponseDesc: "通常RFQは8営業時間以内に返信します。",
  contactDocsTitle: "対応可能書類",
  contactDocsDesc:
    "商業インボイス、梱包明細、物流調整をサポートします。",
  contactSampleTitle: "サンプル対応",
  contactSampleDesc:
    "OEM・プライベートラベル案件向けに迅速にサンプルを手配します。",

  // --- about ---
  aboutTitle: "LOYA SPORTについて",
  aboutIntro:
    "LOYA SPORTは、海外B2Bバイヤー向けにヨガ、ピラティス、軽フィットネス商品を扱う貿易会社です。",
  aboutWhoWeAre: "私たちについて",
  aboutWhoWeAreDesc1:
    "検証済みの供給パートナーと連携し、輸入業者、販売代理店、小売業者、プライベートラベルブランド向けに、調達、サンプル、ブランド加工、出荷フォローを支援します。",
  aboutWhoWeAreDesc2:
    "実務的なコミュニケーション、カテゴリー特化、明確な購買フローにより、海外顧客の導入スピード向上を支援します。",

  aboutSupplyCapabilities: "供給対応力",
  aboutSupplyList1: "ヨガ・軽フィットネス向けの検証済みサプライヤー連携",
  aboutSupplyList2: "提携工場との多段階品質確認",
  aboutSupplyList3: "プライベートラベルおよび包装対応",
  aboutSupplyList4: "EU・米国市場向け輸出サポート",

  aboutProductDev: "商品開発",
  aboutProductDevDesc:
    "迅速なサンプル対応と実務的なデザイン連携により、市場投入を加速します。",
  aboutSupplyReliability: "供給安定性",
  aboutSupplyReliabilityDesc:
    "安定した資材調達と生産計画により、繁忙期でも納期遵守を支援します。",
  aboutTradeSupport: "貿易サポート",
  aboutTradeSupportDesc:
    "書類対応、出荷調整、アフターサポートにより、国際取引を円滑に進めます。",

  aboutMission: "私たちの使命",
  aboutMissionDesc:
    "信頼できる調達、実務的な連携、透明性のある国際取引支援を通じて、フィットネスブランドと小売バイヤーの成長を支援することです。",

  searchOverlayPlaceholder: "商品名で検索...",
  searchOverlaySubmitAria: "検索を実行",
  searchOverlaySubmitTitle: "検索",
  searchOverlayHintPrefix: "",
  searchOverlayHintSuffix:
    "キーで一致する商品を一覧表示できます。下のクイック結果から直接選択することも可能です。",
  searchOverlayCloseAria: "検索を閉じる",
  searchOverlayQuickResults: "クイック結果",
  searchOverlayQuickResultsAria: "クイック検索結果",
  searchOverlayFallbackCategory: "ヨガアクセサリー",
  searchOverlayHistory: "検索履歴",
  searchOverlayClear: "クリア",
  searchOverlayNoHistory: "最近の検索はありません",
  searchOverlayRecommended: "おすすめキーワード",
  searchOverlayFallbackKeyword: "ヨガマット",

  blogHeroKicker: "コンテンツセンター",
  blogHeroTitle: "調達インサイトと購買ガイド",
  blogSearchAria: "記事を検索",
  blogCategoryAria: "記事カテゴリ",
  blogFeaturedPlaceholder: "注目インサイト",
  blogPaginationAria: "ブログページネーション",
  blogCtaAria: "ブログのCTA",
  blogCtaDescription: "サンプル段階から量産納品まで、状況に合わせた提案と伴走支援を行います。",
  blogCtaPrimary: "今すぐ相談",
  blogCtaSecondary: "ソリューションを見る",
  contactInquiryGreeting: "こんにちは、この製品について問い合わせしたいです:",
  contactInquiryProductPrefix: "製品:",
  contactInquiryQuantity: "数量:",
  contactInquiryDestinationPort: "仕向港:",

  aboutHeroKicker: "サプライチェーン統合",
  aboutHeroTitle:
    "私たちは、海外バイヤーの調達・工場調整・輸出納品を、単一の商務チームで統合支援します。",
  aboutHeroBody:
    "LOYA SPORT は、ヨガ・ピラティス・ライトフィットネス領域のサプライチェーン統合者として位置づけています。単なる商品紹介ではなく、サプライヤー、サンプル、包装、品質フォロー、出荷準備を、国際バイヤー向けに実行可能な購買フローへ統合します。",
  aboutMetric1:
    "商品・包装・納品コミュニケーションを一本化する単一プロジェクト窓口",
  aboutMetric2:
    "調達と進行管理の一体構造で連携する複数工場リソース",
  aboutMetric3:
    "輸入業者・小売・代理店・プライベートラベル向けに設計されたB2Bワークフロー",
  aboutPlaceholderNote:
    "私たちの役割は、バイヤー・サプライヤー・工場実行チーム間の分断されたコミュニケーションを減らし、プロジェクトをより明確かつ盲点の少ない形で前進させることです。",
  aboutHeroImageAlt:
    "輸出バイヤー向けサプライチェーン調整ミーティング",
  aboutHeroCaption:
    "問い合わせから出荷まで、通常は調達担当・工場・物流担当に分散しがちな重要項目を私たちが統合調整します。",
  aboutOfficeImageAlt: "長沙のLoya Technologyオフィスビル",
  aboutOfficeCaption: "長沙Loya Technologyオフィス",
  aboutTeamImageAlt: "長沙オフィスのプロフェッショナルチーム",
  aboutFactoryImageAlt: "ヨガマット生産ラインと品質管理フロー",
  aboutFactoryCollageAlt: "工場倉庫と生産ディテール",
  aboutWhatWeDoTitle: "私たちが実際に行うこと",
  aboutWhatWeDoBody1:
    "多くのバイヤーは、カタログだけを必要としていません。商務要件と工場実行を接続できるパートナーが必要です。私たちは、サプライヤー選定、価格協議、サンプル、包装実行、生産フォロー、検査整合、輸出準備を一貫して調整します。",
  aboutWhatWeDoBody2:
    "商品詳細、包装データ、納期、注文変更を個別窓口に分散させず、責任ある単一コミュニケーション経路でプロジェクトを推進します。",
  aboutBadge1: "サプライヤーマッチング",
  aboutBadge2: "サンプルフォロー",
  aboutBadge3: "包装実行",
  aboutBadge4: "出荷準備",
  aboutSideImageAlt: "バイヤーとの打合せと案件レビュー",
  aboutIntegratedCapabilitiesTitle: "統合供給能力",
  aboutSideCaption:
    "私たちは、海外バイヤーにとって調達チェーンをより管理しやすくすることに注力し、断片的な取引ではなく信頼できる協調運用を提供します。",
  aboutCapabilityCard1Title: "サプライヤーネットワーク統合",
  aboutCapabilityCard1Body:
    "工場リソース、カテゴリ知見、調達管理をバイヤー向け単一ワークフローに統合し、複数関係者の個別調整負担を減らします。",
  aboutCapabilityCard2Title: "商務・技術の連携",
  aboutCapabilityCard2Body:
    "見積、サンプル、包装詳細から、仕様確定と生産チェックポイントまで、商務側と工場側を常に整合させます。",
  aboutCapabilityCard3Title: "輸出案件の実行",
  aboutCapabilityCard3Body:
    "検査、書類、ブッキング、出荷準備を一貫して追跡し、コミュニケーション断絶と納品リスクを抑えます。",
  aboutOperatingModel1:
    "対象市場と価格帯に基づくカテゴリ調達と工場マッチング。",
  aboutOperatingModel2:
    "量産固定前のサンプル、仕様レビュー、包装調整。",
  aboutOperatingModel3:
    "単一プロジェクトフローでの生産フォロー、品質チェック、出荷準備。",
  aboutOperatingModel4:
    "商品・包装・書類・納品進捗を一本化したコミュニケーション窓口。",
  aboutWhoWeServeTitle: "支援対象",
  aboutBuyerScenario1Title: "輸入業者・ディストリビューター向け",
  aboutBuyerScenario1Body:
    "商品ラインの統合、サプライヤー比較、カテゴリ横断で安定した補充計画づくりを支援します。",
  aboutBuyerScenario2Title: "小売チェーン・EC販売者向け",
  aboutBuyerScenario2Body:
    "ローンチ可能な品揃え、プライベートラベル包装、再現性ある注文コミュニケーションを支援します。",
  aboutBuyerScenario3Title: "商品ライン拡張中のブランド向け",
  aboutBuyerScenario3Body:
    "コンセプト、製造、輸出実行の間をつなぐ調整レイヤーとして、社内チームの推進速度を高めます。",
  aboutWorkflowTitle: "ワークフロー構成",
  aboutWorkflowStep1: "要件受領と対象商品の明確化",
  aboutWorkflowStep2: "サプライヤーマッチング、見積、サンプル計画",
  aboutWorkflowStep3: "仕様・包装・適合性レビュー",
  aboutWorkflowStep4: "生産フォロー、検査、出荷準備",
  aboutWhyIntegratorTitle:
    "なぜバイヤーはサプライチェーン統合者を使うのか",
  aboutWhyIntegratorBody1:
    "調達が複数サプライヤー、包装業者、出荷スケジュールにまたがると、最大のリスクは初回見積ではなく、注文進行後の整合崩れです。",
  aboutWhyIntegratorList1: "見積と量産の間で仕様がずれる可能性がある。",
  aboutWhyIntegratorList2:
    "包装やブランド詳細が断片的な連絡で遅延する可能性がある。",
  aboutWhyIntegratorList3:
    "検査・書類・出荷準備が当初の商務合意から乖離する可能性がある。",
  aboutWhyIntegratorBody2:
    "私たちの価値は、これらを接続し続けることです。バイヤー期待とサプライヤー実行の間で調整レイヤーとして機能し、意思決定の記録、進捗追跡、引継ぎリスク低減を実現します。",
  aboutTalkToTeam: "チームに相談",
  aboutPositioningTitle: "私たちのポジショニング",
  aboutPositioningBody:
    "LOYA SPORT は、輸出向けフィットネス商品のサプライチェーン統合者として位置づけています。調達から出荷まで、より明確な連携、強いサプライヤー組織、運用しやすい実行ルートで購買を支援します。",

  solutionsHeroKicker: "ソリューション",
  solutionsHeroTitle:
    "バイヤータイプに合った調達ルートを選択",
  solutionsHeroBody:
    "チャネル適合、シナリオ適合、商品プログラム設計を可視化したガイドです。",
  solutionsTalkToSales: "営業に相談",
  solutionsBrowseProducts: "商品を見る",
  solutionsHeroImageAlt:
    "ヨガ・ライトフィットネス向けB2B調達ソリューション",
  solutionsHeroBadgeTitle: "ソリューション適合",
  solutionsHeroBadgeBody: "バイヤータイプ + 利用シーン + 品揃え",
  solutionsBuyerTypeTitle: "バイヤータイプ別ソリューション",
  solutionsViewMatchingProducts: "適合商品を見る",
  solutionsScenarioPlansTitle: "シナリオプラン",
  solutionsProgramMixesTitle: "推奨プログラムミックス",
  solutionsNextStepKicker: "次のステップ",
  solutionsNextStepTitle: "市場に合わせた構成が必要ですか？",
  solutionsNextStepBody:
    "バイヤータイプ、対象商品、仕向け市場を共有してください。実行しやすい商品構成ルートをご提案します。",
  solutionsRequestPlan: "ソリューション提案を依頼",
  solutionsExploreOem: "OEMサポートを見る",

  solutionsBuyerCard1Title: "卸売業者",
  solutionsBuyerCard1Subtitle:
    "大口プログラム向けの迅速なアソート構築。",
  solutionsBuyerCard1Need1:
    "欠品リスクを抑えた安定バルク供給が必要",
  solutionsBuyerCard1Need2:
    "再販を早める箱単位SKUミックスが必要",
  solutionsBuyerCard1Need3:
    "予測可能なリードタイムで反復発注サイクルが必要",
  solutionsBuyerCard1Tag1: "バルクアソート",
  solutionsBuyerCard1Tag2: "箱単位パック",
  solutionsBuyerCard1Tag3: "定期補充",

  solutionsBuyerCard2Title: "小売業者",
  solutionsBuyerCard2Subtitle:
    "棚展開しやすいパックと安定補充。",
  solutionsBuyerCard2Need1:
    "エントリーからプレミアムまで明確な価格階段が必要",
  solutionsBuyerCard2Need2:
    "棚入れを早めるバーコード対応包装が必要",
  solutionsBuyerCard2Need3:
    "回転商品の信頼できる補充体制が必要",
  solutionsBuyerCard2Tag1: "小売パック",
  solutionsBuyerCard2Tag2: "バーコード対応",
  solutionsBuyerCard2Tag3: "陳列向けミックス",

  solutionsBuyerCard3Title: "フィットネスブランド",
  solutionsBuyerCard3Subtitle:
    "ブランド拡張向けプライベートラベルプログラム。",
  solutionsBuyerCard3Need1:
    "供給網を作り直さずにブランドカスタムが必要",
  solutionsBuyerCard3Need2:
    "ブランド定位に合う包装スタイルが必要",
  solutionsBuyerCard3Need3:
    "サンプルから上市までの期間短縮が必要",
  solutionsBuyerCard3Tag1: "ロゴ適用",
  solutionsBuyerCard3Tag2: "カスタム包装",
  solutionsBuyerCard3Tag3: "ライン拡張",

  solutionsBuyerCard4Title: "ヨガスタジオ",
  solutionsBuyerCard4Subtitle:
    "スタジオキット、備品、クラス向けバンドル。",
  solutionsBuyerCard4Need1:
    "新規会員や体験クラス向けのスターターキットが必要",
  solutionsBuyerCard4Need2:
    "高頻度セッションに耐える耐久備品が必要",
  solutionsBuyerCard4Need3:
    "アップセルしやすい実用的なバンドル価格が必要",
  solutionsBuyerCard4Tag1: "スターターセット",
  solutionsBuyerCard4Tag2: "クラス備品",
  solutionsBuyerCard4Tag3: "会員アップグレードキット",

  solutionsBuyerCard5Title: "Amazon販売者",
  solutionsBuyerCard5Subtitle:
    "マーケットプレイス向けに最適化されたバンドルと包装。",
  solutionsBuyerCard5Need1:
    "送料を抑えるコンパクトなバンドル構成が必要",
  solutionsBuyerCard5Need2:
    "転換率を高める商品組み合わせが必要",
  solutionsBuyerCard5Need3:
    "返品率を下げる包装品質が必要",
  solutionsBuyerCard5Tag1: "コンパクトバンドル",
  solutionsBuyerCard5Tag2: "掲載向け包装",
  solutionsBuyerCard5Tag3: "低摩擦ローンチ",

  solutionsBuyerCard6Title: "EC事業者",
  solutionsBuyerCard6Subtitle:
    "継続的なオンライン販売向けのビジュアル重視商品。",
  solutionsBuyerCard6Need1:
    "広告とSNSで強いヒーローSKUが必要",
  solutionsBuyerCard6Need2:
    "AOV向上のため柔軟なバンドルが必要",
  solutionsBuyerCard6Need3:
    "季節キャンペーン向けの迅速なカタログ更新が必要",
  solutionsBuyerCard6Tag1: "ヒーロー商品",
  solutionsBuyerCard6Tag2: "バンドル設計",
  solutionsBuyerCard6Tag3: "高速カタログ更新",

  solutionsScenario1Title: "スタジオ向けスターターセット",
  solutionsScenario1Body:
    "クラス、体験、会員パック向けに、すぐ展開できるヨガバンドル。",
  solutionsScenario2Title: "リカバリー＆マッサージゾーン",
  solutionsScenario2Body:
    "ジムの一角向けに、マッサージツール、ローラー、回復アクセサリーを構成。",
  solutionsScenario3Title: "小売陳列プログラム",
  solutionsScenario3Body:
    "棚見せに適した包装で、バランスの取れたアソートを実現。",
  solutionsScenario4Title: "オンラインバンドル提案",
  solutionsScenario4Body:
    "転換重視の商品ページ向けに設計されたコンパクトキット。",

  solutionsProgram1Title: "スタジオ立ち上げミックス",
  solutionsProgram1Body:
    "クラス運営型ヨガビジネス向けの明快なスターター構成。",
  solutionsProgram1Item1: "ヨガマット",
  solutionsProgram1Item2: "ブロック＆ストラップ",
  solutionsProgram1Item3: "マッサージアクセサリー",
  solutionsProgram1SuitedFor: "スタジオ / トレーナー",

  solutionsProgram2Title: "小売棚向けプログラム",
  solutionsProgram2Body:
    "明確な価格階層と反復発注が必要な店舗向けのバランス型商品ファミリー。",
  solutionsProgram2Item1: "コアマット",
  solutionsProgram2Item2: "ピラティス備品",
  solutionsProgram2Item3: "衝動買い向け回復ツール",
  solutionsProgram2SuitedFor: "小売 / ディストリビューター",

  solutionsProgram3Title: "オンラインバンドルパック",
  solutionsProgram3Body:
    "PDPビジュアルとオンライン転換を高めるコンパクト構成セット。",
  solutionsProgram3Item1: "ミニキット",
  solutionsProgram3Item2: "ギフト向けパック",
  solutionsProgram3Item3: "プライベートラベル同梱物",
  solutionsProgram3SuitedFor: "Amazon / EC",

  admin: {
    ...(en.admin || {}),

    // --- categories / faq / company images ---
    productCategoryYogaMats: "ヨガマット",
    productCategoryYogaBlocks: "ヨガブロック",
    productCategoryYogaStraps: "ヨガストラップ",
    productCategoryResistanceBands: "レジスタンスバンド",
    productCategoryPilatesRings: "ピラティスリング",
    productCategoryFoamRollers: "フォームローラー",
    productCategoryOthers: "その他",

    faqSampleOrderQ: "サンプル注文は可能ですか？",
    faqSampleOrderA:
      "はい、サンプル注文に対応しています。お気軽にお問い合わせください。",
    faqCustomPackagingQ:
      "カスタム包装やロゴ対応は可能ですか？",
    faqCustomPackagingA:
      "はい、OEM/ODMのカスタマイズサービスに対応しています。",
    faqLeadTimeQ: "納期はどのくらいですか？",
    faqLeadTimeA:
      "通常は注文数量により1～3日程度です。最終的な納期は正式発注時に確認となります。",
    faqDefectiveItemQ: "不良品はどのように対応しますか？",
    faqDefectiveItemA:
      "出荷日から1年間の保証を提供しています。保証期間内に、素材または製造上の問題による不良が発生した場合は、説明、写真または動画、必要に応じて不良サンプルをご提供ください。弊社エンジニアが分析し、対応策をご案内します。返品をご希望の場合は、元の梱包と付属品を揃えてご返送ください。返品品到着後に返金、または無償交換品を発送します。",
    faqWhyChooseUsQ: "なぜ当社を選ぶべきですか？",
    faqWhyChooseUsA:
      "当社の商品は低MOQかつ高品質で、米国・EU基準に対応可能です。高水準のサービスを提供し、OEMおよびTrade Assurance注文にも対応しています。安心してお取引いただけます。",

    companyImageSectionOverview: "会社概要",
    companyImageSectionAdvantages: "競争優位性",
    companyImageSectionCustomization: "カスタマイズ対応力",
    companyImageSectionExtended: "詳細会社紹介",
    companyImageSectionPackaging: "包装・出荷仕様",
    companyImageSectionFactory: "工場紹介",
    companyImageSectionWorkflow: "生産フロー",
    companyImageSectionTradeShow: "展示会参加実績",

    // --- order status / tab descriptions ---
    orderStatusPaid: "支払い済み",
    orderStatusPacked: "梱包済み",
    orderStatusInTransit: "輸送中",
    orderStatusDelivered: "配達完了",
    orderStatusCancelled: "キャンセル",

    tabDescHome:
      "ここでワークスペースの業務を管理し、パフォーマンスを確認できます。",
    tabDescStoreBase:
      "ストア／管理画面のタイトルとSEOメタデータを設定します。",
    tabDescTemplateStudio: "ストアフロントのレイアウトモジュールを視覚的に編集し、カスタムテンプレートを保存します。",
    tabDescArticleManagement:
      "専用ワークスペースでブログ記事を管理し、ダイアログ形式で編集できます。",
    tabDescCompanyImages:
      "ストアフロントの会社紹介用に分類済みの会社画像アセットを管理します。",
    tabDescDesignNav:
      "ストアフロントのナビゲーションおよび階層メニュー構成を設定します。",
    tabDescDesignCarousel:
      "ストアフロントのメインビジュアル用カルーセル画像を管理します。",
    tabDescDesignBanner:
      "バナーメッセージおよびCTAコンテンツを設定します。",
    tabDescFaqKnowledge:
      "営業・運営チームで使用するFAQコンテンツを管理します。",
    tabDescProducts:
      "商品カタログ、詳細情報、価格情報を管理します。",
    tabDescProductCreate:
      "詳細情報とメディアを含む新規商品を作成します。",
    tabDescMerchandising:
      "候補商品の評価、価格構成、発売準備状況を確認します。",
    tabDescProcurement:
      "購買計画、サプライヤー進捗、調達優先度を調整します。",
    tabDescQuality:
      "出荷前の検査項目とリリース準備状況を追跡します。",
    tabDescLogistics:
      "出荷状況、包装準備、追跡連携を確認します。",
    tabDescOrders:
      "注文ライフサイクル、履行状況、出荷更新を追跡します。",
    tabDescCustomers:
      "チームメンバーとそのアカウント権限をここで管理します。",
    tabDescMarketing:
      "キャンペーン状況と成長パフォーマンスを確認します。",
    tabDescDiscounts:
      "割引戦略と販促ルールを管理します。",
    tabDescFinance:
      "財務記録と売上推移を確認します。",
    tabDescFinanceIncome: "注文代金の回収、認識された収益、および収益台帳の入力を確認します。",
    tabDescFinanceExpenses: "仕入れ、物流、マーケティング、および一般管理費の請求書を追跡します。",
    tabDescFinanceReceivables: "売掛残高、経過年数分析、および回収優先度を追跡します。",
    tabDescFinancePayables: "買掛残高、サプライヤー払い、および期日が迫っている案件を管理します。",
    tabDescFinanceInvoices: "請求書、領収書、および請求ステータスを管理します。",
    tabDescFinanceTax: "仮受消費税、仮払消費税、および税務見積もりを確認します。",
    tabDescFinanceBudget: "予算、支出配分、および超過アラートを追跡します。",
    tabDescFinanceDaily: "会社の収益、支出、および純キャッシュフローを日次で集計します。",
    tabDescFinanceMonthly: "月次帳簿を締め、利益および予算差異を確認します。",
    tabDescFinanceYearly: "年間売上、支出、税務、および純利益を確認します。",
    tabDescFinanceReconciliation: "売掛残高、回収、買掛残高、請求書、および税務状況を照合します。",
    tabDescFinanceApprovals: "返金、支払い、および経費の承認監査を管理します。",
    tabDescFinanceReports: "財務諸表、業務指標、およびエクスポート作業をまとめます。",
    tabDescAnalytics:
      "データ分析と業務指標を確認します。",
    tabDescSettings:
      "データベース接続などのシステム下位設定を管理します。",
    tabDescWorkTargets:
      "日々の業務目標を追跡・調整します。",
    tabDescWorkProcessing:
      "割り当てられたワークフローと実行記録を処理します。",
    tabDescHrEmployee:
      "従業員プロフィールとアカウント情報を確認・管理します。",
    tabDescHrRecruitment:
      "採用およびオンボーディング関連タスクを追跡します。",
    tabDescHrAttendance:
      "出勤状況とアカウント活動状況を確認します。",
    tabDescHrOffice:
      "役割配置と社内事務タスクを管理します。",
    tabDescSiteMaintenance:
      "ストアフロントの内容とサイト安定性を維持します。",
    tabDescPermissionMaintenance:
      "ロールベース権限とアクセス範囲を管理します。",
    tabDescPositionMaintenance: "",
    tabDescProfile: "アカウント情報を確認します。",
    tabDescPassword: "アカウントのパスワードを安全に変更します。",
    tabDescInquiry:
      "販売者へ連絡し、問い合わせ対応を継続します。",
    tabDescWishlist:
      "保存済み商品と優先調達アイテムを管理します。",
    tabDescOrderProcessing:
      "注文処理のライフサイクル記録を追跡・処理します。",
    tabDescAfterSales:
      "アフターサービス依頼とサポートチケットを追跡します。",

    // --- roles / menus ---
    roleDeveloper: "開発者",
    roleSuperAdmin: "スーパー管理者",
    roleAdmin: "管理者",
    roleCustomer: "顧客",
    roleGuest: "ゲスト",

    productCreateMenu: "商品公開",
    productsMenu: "商品管理",
    merchandisingOverview: "マーチャンダイジング概要",
    merchandisingCollection: "収集済みプール",
    internalOverview: "概要と設定",
    internalWorkspace: "カタログと履行",
    internalBusiness: "営業と顧客",
    internalOffice: "役割別ワークスペース",
    internalMaintenance: "保守パネル",
    storefrontContent: "ストア内容",
    guestService: "ゲストサービス",
    customerService: "顧客サービス",
    commonAccount: "マイアカウント",
    siteMaintenanceMenu: "役職管理",
    positionMaintenanceMenu: "ユーザー管理",

    title: "マイストア",
    home: "業務概要",
    storeDesign: "ストア設定",
    companyProfile: "会社概要",
    storeBase: "ストア基本設定",
    templateStudio: "テンプレートスタジオ",
    articleManagement: "記事管理",
    companyProfileMenu: "会社紹介",
    companyImages: "会社画像",
    designNav: "ナビゲーションメニュー",
    designCarousel: "ホームカルーセル",
    designBanner: "バナー設定",
    faqKnowledge: "FAQナレッジベース",
    products: "商品管理",
    productCreate: "商品作成",
    merchandising: "マーチャンダイジングセンター",
    procurement: "調達センター",
    quality: "品質センター",
    logistics: "物流連携",
    orders: "問い合わせ・注文",
    customers: "顧客管理",
    marketing: "キャンペーン",
    discounts: "価格戦略",
    finance: "財務概要",
    financeIncome: "収益台帳",
    financeExpenses: "経費請求書",
    financeReceivables: "应値残高",
    financePayables: "買授残高",
    financeInvoices: "請求書管理",
    financeTax: "税務管理",
    financeBudget: "予算・支出",
    financeDaily: "日次請求書",
    financeMonthly: "月次結算",
    financeYearly: "年次財務諸表",
    financeReconciliation: "照合",
    financeApprovals: "承認・監査",
    financeReports: "レポート・エクスポート",
    analytics: "データ分析",
    settings: "システム設定",

    menuCommon: "共通",
    menuInternal: "内部",
    menuWorkContent: "業務内容",
    menuMaintenance: "保守パネル",
    userManagementGroup: "保守パネル",
    menuGuest: "ゲスト",
    menuCustomer: "顧客",

    workTargets: "業務目標",
    workProcessing: "業務処理",
    hrEmployee: "従業員プロフィール",
    hrRecruitment: "採用",
    hrAttendance: "勤怠",
    hrOffice: "社内管理",
    siteMaintenance: "役職管理",
    permissionMaintenance: "権限管理",
    positionMaintenance: "ユーザー管理",
    profile: "マイプロフィール",
    password: "パスワード変更",
    inquiry: "問い合わせメッセージ",
    wishlist: "お気に入り",
    orderProcessing: "注文処理",
    afterSales: "アフターサービス",

    // --- profile / password / inquiry ---
    profileCardTitle: "個人情報",
    accountId: "アカウントID",
    profileName: "氏名",
    profileEmail: "メール",
    profileRole: "役割",

    passwordCardTitle: "アカウントパスワード更新",
    currentPassword: "現在のパスワード",
    adminResetPasswordHint:
      "この操作は対象ユーザーのパスワードをリセットします。現在のパスワードは不要です。",
    newPassword: "新しいパスワード",
    confirmPassword: "新しいパスワード確認",
    savePassword: "パスワード更新",
    passwordUpdated: "パスワードを更新しました。",

    inquiryCardTitle: "問い合わせ対応",
    inquiryCardBody:
      "商品要件、見積もり、納期計画について販売チームへお問い合わせください。",
    openInquiryCenter: "お問い合わせページを開く",
    openWhatsappChat: "WhatsAppチャット",

    permissionSectionTitle: "現在の権限セット",
    permissionSectionBody:
      "権限はログイン情報から判定され、役職構成に基づいて割り当てられます。",
    placeholderTodo:
      "このモジュールは現在の役職で利用可能です。ここに具体的な業務アクションを拡張できます。",

    // --- settings / system / base ---
    systemConfigTitle: "システム設定センター",
    settingsTabDatabase: "データベース",
    settingsTabDatabaseHint: "接続とプール設定",
    settingsTabEmail: "メール",
    settingsTabEmailHint: "ブランド設定と通知テンプレート",

    mysqlHost: "MySQLホスト",
    mysqlPort: "MySQLポート",
    mysqlDatabase: "MySQLデータベース",
    mysqlUser: "MySQLユーザー",
    mysqlPassword: "MySQLパスワード",
    mysqlPoolSize: "MySQLプールサイズ",
    mysqlConnectTimeoutMs: "MySQL接続タイムアウト (ms)",

    saveSystemConfig: "システム設定を保存",
    systemConfigSavedToast: "システム設定を保存しました",
    systemConfigPathLabel: "設定ファイル",
    restartRequiredHint:
      "新しいDB設定を反映するには、保存後にバックエンドを再起動してください。",

    storefrontTitle: "ストアタイトル",
    adminTitle: "管理画面タイトル",
    seoMetaTitle: "SEOメタタイトル",
    seoDescription: "SEOメタ説明",
    seoKeywords: "SEOキーワード",
    seoCanonicalUrl: "正規URL",
    seoRobots: "SEO robots",
    seoOgTitle: "Open Graphタイトル",
    seoOgDescription: "Open Graph説明",
    seoOgImage: "Open Graph画像URL",
    seoTwitterCard: "Twitterカード種別",
    seoTwitterSite: "Twitterサイト／アカウント",

    saveBaseSettings: "基本設定を保存",
    baseSavedToast: "基本設定を保存しました",

    // --- common ui ---
    hello: "こんにちは。始めましょう。",
    askAnything: "何でも入力してください...",
    supportLine: "サポートが必要ですか？ サポートへご連絡ください",

    addStoreName: "ストア名を追加",
    firstProduct: "最初の商品を追加",
    firstProductDesc:
      "まず商品と主要情報を追加して、販売準備を進めましょう。",
    addProduct: "商品追加",
    importData: "インポート",

    customizeStore: "オンラインストアをカスタマイズ",
    customizeStoreDesc:
      "テンプレートを選び、ロゴ、カラー、画像を追加してください。",
    customTemplate: "カスタムテンプレート",
    payments: "支払い設定",
    shipping: "配送費を確認",
    domain: "独自ドメイン",

    quickSales: "マルチチャネル販売を簡素化",
    quickSalesDesc:
      "複数のマーケットプレイス掲載を1か所で管理できます。",

    storeSettings: "ストア設定",
    general: "一般",
    billing: "請求",
    usersPermissions: "ユーザー",

    paginationPrevious: "前へ",
    paginationNext: "次へ",
    paginationPage: "ページ",
    paginationTotal: "合計",

    policies: "ポリシー",
    businessInfo: "事業情報",
    contactInfo: "ストア連絡先",
    defaults: "ストア既定値",

    businessMode: "事業モード",
    b2b: "B2B",
    b2c: "B2C",
    modeSaved: "ストアモードを更新しました",
    modeSavedToast: "事業モードを切り替えました",

    navSettings: "ナビゲーションメニュー",
    navLabel: "サブメニュー名",
    navPath: "サブメニューリンク",
    addSubmenu: "サブメニュー追加",
    saveNavigation: "サブメニュー一覧を保存",
    navSavedToast: "ナビゲーションメニューを保存しました",

    bannerSettings: "カルーセル一覧",
    bannerTitle: "バナータイトル",
    bannerAnnotation: "画像注記",
    bannerButtonText: "ボタン名",
    bannerButtonLink: "ボタンリンク",
    bannerImageUrl: "バナー画像URL",
    addBanner: "バナー追加",
    removeBanner: "削除",
    saveBanners: "カルーセル一覧を保存",
    bannersSavedToast: "カルーセル一覧を保存しました",

    saveFaqKnowledge: "FAQナレッジを保存",
    faqKnowledgeSavedToast: "FAQナレッジを保存しました",
    saveCompanyImages: "会社画像を保存",
    companyImagesSavedToast: "会社画像設定を保存しました",

    companyIntroductionTitle: "会社紹介",
    companyIntroductionHint:
      "会社概要、強み、サービス対応力を記載してください。",
    companyIntroductionPlaceholder:
      "会社紹介内容を入力してください...",
    addImageUrl: "画像URLを追加",
    uploadLocalImages: "ローカル画像をアップロード",
    addFaq: "FAQ追加",
    saveCarouselImages: "カルーセル画像を保存",
    carouselImagesSavedToast: "カルーセル画像を保存しました",

    close: "閉じる",
    save: "保存",
    create: "作成",
    search: "現在タブ内を検索",
    refresh: "更新",
    createProduct: "商品作成",
    cancel: "キャンセル",
    edit: "編集",
    remove: "削除",

    systemSnapshot: "システムスナップショット",
    activeSearch: "現在タブ検索",
    none: "(なし)",
    orderRecords: "注文記録",
    userRecords: "ユーザー記録",
    lastRefresh: "最終更新",
    productsCount: "商品数",
    customersCount: "顧客数",
    ordersCount: "注文数",
    revenue: "売上 USD",

    localeLabel: "言語",
    sku: "SKU",
    name: "名称",
    description: "説明",
    price: "価格 USD",
    imageUrl: "画像URL",
    category: "カテゴリー",
    model: "型番",
    titleField: "商品タイトル",
    detailVideo: "詳細動画URL",
    mainImages: "メイン画像（6件、1行1URL）",
    detailImages: "詳細画像（1行1URL）",
    parameters: "パラメータ（1行ごとに key:value）",
    openCreateProduct: "商品詳細フォームを開く",

    id: "ID",
    serialNumber: "番号",
    userId: "ユーザーID",
    actions: "操作",
    email: "メール",
    role: "役割",
    username: "ユーザー名",
    nickname: "ニックネーム",
    userRole: "ユーザー役割",
    phone: "電話番号",
    accountStatus: "アカウント状態",
    jobTitle: "役職名",
    registeredAt: "登録日時",
    lastActiveAt: "最終アクティブ日時",
    statusActive: "有効",
    statusDisactive: "無効",
    permissions: "権限",
    position: "役職",
    accessSummary: "アクセス",
    positionName: "役職名",
    positionKey: "役職キー",
    department: "部署",
    addPosition: "役職追加",
    permissionName: "権限名",
    permissionKey: "権限キー",
    addPermission: "権限追加",
    editPermissions: "権限編集",
    permissionSelectTitle: "権限選択",
    permissionSelectedSummary: "選択済み権限",
    permissionQuickSearchPlaceholder:
      "キーまたは注記でクイック検索",
    defaultAdminPosition: "運営管理者",

    orderId: "注文",
    total: "合計",
    status: "状態",
    cartItems: "カート商品",
    logout: "ログアウト",
    changePasswordAction: "パスワード変更",
    userPasswordModalTitle: "ユーザーパスワードをリセット",
    userPasswordUpdated: "ユーザーパスワードを更新しました。",
    targetUser: "対象ユーザー",
    userDataResyncedHint:
      "保存後、プロフィール項目をサーバーから再同期しました。",
    userManagementRestrictedHint:
      "この操作にはより高い権限が必要です。",

    capability: {
      ...((en.admin && en.admin.capability) || {}),

      "admin:overview:read": "管理概要を見る",
      "admin:products:read": "管理商品を見る",
      "admin:products:write": "管理商品を編集",
      "admin:orders:read": "管理注文を見る",
      "admin:orders:write": "管理注文を編集",
      "admin:users:read": "管理ユーザーを見る",
      "admin:users:role:write": "ユーザー役割を編集",
      "admin:users:position:assign": "ユーザーに役職を割り当て",
      "admin:storefront:read": "ストア設定を見る",
      "admin:storefront:write": "ストア設定を編集",
      "admin:system-config:read": "システム設定を見る",
      "admin:system-config:write": "システム設定を編集",
      "shop:profile:read": "ストアプロフィールを見る",
      "shop:password:write": "ストアパスワードを更新",
      "shop:orders:read": "ストア注文を見る",
      "shop:inquiry:write": "ストア問い合わせを処理",
      "shop:wishlist:read": "お気に入りを見る",
      "shop:orders:processing:read": "注文処理を見る",
      "shop:after-sales:read": "アフターサービスを見る",
      "internal:work:targets:read": "業務目標を見る",
      "internal:work:processing:read": "業務処理を見る",
      "internal:maintenance:site:write": "サイト保守を編集",
      "internal:maintenance:permission:write": "権限保守を編集",
      "internal:maintenance:position:write": "役職保守を編集",
      "shop:products:read": "ストア商品を見る",
      "shop:storefront:read": "ストアフロントを見る",
      "internal:system:config:read": "内部システム設定を見る",
      "internal:system:config:write": "内部システム設定を編集",
      "internal:security:audit:read": "セキュリティ監査を見る",
      "internal:security:session:revoke": "セッションを無効化",
      "internal:integration:manage": "連携を管理",
      "admin:users:write": "管理ユーザーを編集",
      "admin:users:password:reset": "ユーザーパスワードをリセット",
      "admin:users:delete": "管理ユーザーを削除",
      "crm:customer:read": "顧客記録を見る",
      "crm:customer:write": "顧客記録を編集",
      "crm:customer:assign": "顧客を割り当て",
      "website:content:read": "サイト内容を見る",
      "website:content:write": "サイト内容を編集",
      "website:navigation:write": "サイトナビゲーションを編集",
      "website:banner:write": "サイトバナーを編集",
      "website:seo:write": "SEO設定を編集",
      "website:theme:write": "サイトテーマを編集",
      "website:publish": "サイト内容を公開",
      "admin:products:create": "管理商品を作成",
      "admin:products:delete": "管理商品を削除",
      "merchandising:selection:read": "マーチャンダイジング選定を見る",
      "merchandising:selection:write": "マーチャンダイジング選定を編集",
      "catalog:pricing:write": "カタログ価格を編集",
      "catalog:inventory:write": "在庫を編集",
      "catalog:translation:write": "カタログ翻訳を編集",
      "sales:inquiry:read": "営業問い合わせを見る",
      "sales:inquiry:reply": "営業問い合わせに返信",
      "sales:quotation:create": "見積書を作成",
      "sales:quotation:approve": "見積書を承認",
      "sales:contract:write": "営業契約を編集",
      "sales:sample:manage": "サンプルを管理",
      "order:status:update": "注文状態を更新",
      "order:split:merge": "注文を分割・統合",
      "procurement:purchase:write": "購買注文を編集",
      "production:plan:write": "生産計画を編集",
      "qa:inspection:write": "品質検査を編集",
      "logistics:shipment:write": "出荷記録を編集",
      "logistics:tracking:read": "出荷追跡を見る",
      "trade:customs:doc:write": "通関書類を編集",
      "finance:invoice:read": "請求書を見る",
      "finance:invoice:write": "請求書を編集",
      "finance:payment:read": "支払いを見る",
      "finance:payment:write": "支払いを編集",
      "finance:refund:approve": "返金を承認",
      "finance:reconciliation:write": "照合記録を編集",
      "finance:tax:write": "税設定を編集",
      "marketing:campaign:read": "マーケティング施策を見る",
      "marketing:campaign:write": "マーケティング施策を編集",
      "marketing:coupon:write": "クーポンを編集",
      "marketing:lead:export": "リードをエクスポート",
      "analytics:dashboard:read": "分析ダッシュボードを見る",
      "analytics:report:export": "分析レポートをエクスポート",
      "support:ticket:read": "サポートチケットを見る",
      "support:ticket:write": "サポートチケットを編集",
      "support:return:approve": "返品を承認",
      "support:complaint:handle": "クレーム対応",
      "office:announcement:write": "社内告知を公開",
      "office:document:read": "社内文書を見る",
      "office:document:write": "社内文書を編集",
      "office:workflow:approve": "社内ワークフローを承認",
      "office:meeting:manage": "会議を管理",
      "hr:employee:read": "従業員プロフィールを見る",
      "hr:employee:write": "従業員プロフィールを編集"
    }
  },
  blogReadingTimeMin: "分で読めます",
  blogShowLess: "表示を減らす",
  requestFreeSample: "無料サンプルを依頼",
  factoryStatsSince: "1995年から",
  factoryStatsCapacity: "月間10,000点以上",
  factoryStatsExport: "50か国以上へ輸出",
  factoryStatsCert: "ISO 9001・BSCI認証取得",
  aboutAddress: "住所: 中国湖南省長沙市岳麓区旺龍路 瑞和科創ビル",
  aboutTeamTitle: "活気あるプロフェッショナルチーム",
  aboutTeamBody: "私たちは若さと経験を兼ね備え、市場ニーズとヨガ業界の技術的要点を深く理解しています。厳格な選定ロジックと迅速な対応により、納品する全ての製品が高い商業基準を満たすようにしています。",
  aboutCustomizationTitle: "総合的なカスタマイズサービス",
  aboutCustomizationBody: "ロゴ印刷、包装設計から製品機能の金型開発まで、柔軟で踏み込んだカスタマイズ提案で、ブランドの市場差別化を支援します。",
  aboutFactoryPartnerTitle: "高品質な工場パートナー",
  aboutFactoryPartnerBody: "ISO/BSCI認証を持つ製造拠点と密に連携し、源流から品質を管理して、生産の安定性と納期遵守を確保します。",
  oemServiceShowcaseAria: "OEM・ODMカスタマイズサービス",
  oemServiceShowcaseTitle: "OEM・ODMカスタマイズサービス",
  oemServiceShowcaseBody: "構想レビューから生産、出荷引き継ぎまで、柔軟なワンストップ支援を提供します。",
  oemCompareHeadBody: "よくある4つの進め方を、ベース版とカスタム結果で比較表示します。",
  oemCompareBaseSuffix: "ベース版",
  oemCompareOptionsSuffix: "カスタマイズ項目",
  oemCompareCustomizedSuffix: "カスタム版",
  oemCompare1Title: "ロゴ適用",
  oemCompare1Body: "無地製品をブランド仕様へ。",
  oemCompare1BeforeLabel: "ベース",
  oemCompare1AfterLabel: "ロゴ入り",
  oemCompare1CustomizationLabel: "ロゴ追加",
  oemCompare1Item1: "印刷",
  oemCompare1Item2: "エンボス",
  oemCompare1Item3: "レーザーマーク",
  oemCompare2Title: "色と仕上げ",
  oemCompare2Body: "中立仕様から市場適合のカラーバリエーションへ。",
  oemCompare2BeforeLabel: "標準",
  oemCompare2AfterLabel: "カスタムカラー",
  oemCompare2CustomizationLabel: "色更新",
  oemCompare2Item1: "カラー",
  oemCompare2Item2: "質感",
  oemCompare2Item3: "サイズ",
  oemCompare3Title: "包装仕様",
  oemCompare3Body: "簡易包装から店頭対応パッケージへ。",
  oemCompare3BeforeLabel: "簡易包装",
  oemCompare3AfterLabel: "店頭対応",
  oemCompare3CustomizationLabel: "包装詳細",
  oemCompare3Item1: "同梱カード",
  oemCompare3Item2: "バーコード",
  oemCompare3Item3: "外箱マーク",
  oemCompare4Title: "バンドル開発",
  oemCompare4Body: "単品からチャネル向けセットへ。",
  oemCompare4BeforeLabel: "単品",
  oemCompare4AfterLabel: "バンドルセット",
  oemCompare4CustomizationLabel: "セット設計",
  oemCompare4Item1: "スタジオセット",
  oemCompare4Item2: "Amazon向けパック",
  oemCompare4Item3: "販促ミックス",
  oemCasesTitle: "カスタマイズ事例",
  oemCase1Title: "ブティックスタジオ向けスターターライン",
  oemCase1Summary: "ブティックスタジオ立ち上げ向けスターターキット提案。",
  oemCase1Details: "ロゴ対応バンドルを12日で承認。",
  oemCase2Title: "小売向けプライベートラベル刷新",
  oemCase2Summary: "棚映えを高めるために包装デザインを更新。",
  oemCase2Details: "バイヤー承認の迅速化と小売表現の一貫性向上を実現。",
  oemCase3Title: "マーケットプレイス対応フィットネスバンドル",
  oemCase3Summary: "EC販売と商品ページ運用向けにバンドル構成を準備。",
  oemCase3Details: "同梱物、バーコード、量産レビューまで準備完了。",
  oemOrderingFlowKicker: "発注フロー",
  oemOrderingFlowTitle: "5ステップで相談から発注まで",
  oemContactFlow1: "製品リスト、販売先市場、ブランド要件を含む初回相談。",
  oemContactFlow2: "サンプル計画、納期、包装オプションを含む見積提示。",
  oemContactFlow3: "サンプル確認と発注詳細の承認。",
  oemContactFlow4: "前金、生産、検品、出荷手配。",
  oemContactFlow5: "残金支払い、輸出書類、アフターサポート。",
  oemContactSideTitle: "OEMのご相談を始めますか？",
  oemContactSideBody: "ロゴ、目標数量、包装アイデアをお送りください。実務的な見積ルートとサンプル提案をご案内します。",
  oemContactSideNote: "初回連絡の推奨: メールまたは問い合わせフォーム（デザインデータと希望出荷時期を添付）。",
  oemContactSideCta: "営業チームに連絡",
  requestQuote: "見積を依頼",
  trustTitle: "グローバルパートナーと信頼",
  factoryStatsSize: "30,000平方メートル工場",
  factoryStatsQC: "工程内・最終検査ともに100%実施",
  homeAriaTrust: "信頼とパートナー",
  homeAriaStats: "工場実績データ",
};
